export default function Skeleton({ width, height, borderRadius = 6, style = {} }) {
  return (
    <div style={{
      width: width || "100%",
      height: height || 16,
      borderRadius,
      background: "linear-gradient(90deg, #1a1a1a 25%, #2a2a2a 50%, #1a1a1a 75%)",
      backgroundSize: "200% 100%",
      animation: "shimmer 1.5s infinite",
      flexShrink: 0,
      ...style
    }} />
  );
}

export function SongRowSkeleton() {
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 12, padding: "10px 16px" }}>
      <Skeleton width={20} height={20} borderRadius={4} />
      <Skeleton width={46} height={46} borderRadius={8} />
      <div style={{ flex: 1, display: "flex", flexDirection: "column", gap: 6 }}>
        <Skeleton width="70%" height={14} />
        <Skeleton width="45%" height={11} />
      </div>
    </div>
  );
}

export function CardSkeleton() {
  return (
    <div style={{ flexShrink: 0, width: 120 }}>
      <Skeleton width={120} height={120} borderRadius={10} style={{ marginBottom: 8 }} />
      <Skeleton width="80%" height={12} style={{ marginBottom: 4 }} />
      <Skeleton width="55%" height={10} />
    </div>
  );
}

export function HomeSkeletons() {
  return (
    <div style={{ background: "#000", minHeight: 400 }}>
      <style>{`@keyframes shimmer { 0%{background-position:200% 0} 100%{background-position:-200% 0} }`}</style>
      {/* Recently played */}
      <div style={{ padding: "20px 16px 0" }}>
        <Skeleton width={140} height={17} style={{ marginBottom: 14 }} />
        <div style={{ display: "flex", gap: 12, overflowX: "hidden" }}>
          {[1,2,3].map(i => <CardSkeleton key={i} />)}
        </div>
      </div>
      {/* Top hits */}
      <div style={{ padding: "20px 16px 0" }}>
        <Skeleton width={100} height={17} style={{ marginBottom: 14 }} />
        <div style={{ display: "flex", gap: 12, overflowX: "hidden" }}>
          {[1,2,3].map(i => <CardSkeleton key={i} />)}
        </div>
      </div>
      {/* Song rows */}
      <div style={{ padding: "20px 16px 0" }}>
        <Skeleton width={120} height={17} style={{ marginBottom: 14 }} />
        {[1,2,3,4,5].map(i => <SongRowSkeleton key={i} />)}
      </div>
    </div>
  );
}